import LoginPage from "./pages/login-page";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import HomePage from "./pages/home-page";
import AgendaPage from "./pages/agenda-page";
import AtendimentoPage from "./pages/atendimento-page";
import Map from "./components/map";
import ErrorPage from "./pages/error-page";
import AdminPage from "./pages/admin-page";
import AtendimentoAvulso from "./pages/atendimento-avulso";
import Atendimento1 from "./components/atendimento-avulso-component";
import SimulacaoPlanilha from "./pages/planilha-custos";
import ConfiguracaoPage from "./pages/configuracao-page";
import HistoricoPrecosPage from "./pages/historico-precos-page";
import OrdemCarregamentoPage from "./pages/ordem-carregamento-page";
import OrdemCarregamentoExecucaoPage from "./pages/ordem-carregamento-execucao-page";
import PortalSsoPage from "./pages/portal-sso-page";
import SessionWatcher from "./components/session-watcher";

function App() {
  return (
    <Router>
      <SessionWatcher />
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/agenda" element={<AgendaPage />} />
        <Route path="/atendimento/:index" element={<AtendimentoPage />} />
        <Route path="/maps" element={<Map />} />
        <Route path="/error" element={<ErrorPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/atendimento" element={<AtendimentoAvulso />} />
        <Route path="/atendimento-1" element={<Atendimento1 />} />
        <Route path="/simulacao-custos" element={<SimulacaoPlanilha />} />
        <Route path="/configuracao" element={<ConfiguracaoPage />} />
        <Route
          path="/frota"
          element={<Navigate to="/configuracao" replace />}
        />
        <Route
          path="/motoristas"
          element={<Navigate to="/configuracao" replace />}
        />
        <Route
          path="/produtos"
          element={<Navigate to="/configuracao" replace />}
        />
        <Route
          path="/fornecedores"
          element={<Navigate to="/configuracao" replace />}
        />
        <Route path="/historico-precos" element={<HistoricoPrecosPage />} />
        <Route
          path="/ordem-carregamento"
          element={<OrdemCarregamentoPage />}
        />
        <Route
          path="/ordem-carregamento/:pedidoId"
          element={<OrdemCarregamentoExecucaoPage />}
        />
        <Route path="/sso-login" element={<PortalSsoPage />} />
      </Routes>
    </Router>
  );
}

export default App;
